module.exports = __webpack_public_path__ + "img/淡印黑膜白底.6f91b931.jpg";